export default {
  namespaced: true,
  state: {
    summary: null,
    selectedYear: "",
    summaryVisible: false
  },
  mutations: {
    setSummary(state, summary) {
        state.summary = summary;
    },
    setSelectedYear(state, selectedYear) {
      state.selectedYear = selectedYear;
    },
    setSummaryvisible(state) {
        state.summaryVisible = true;       
        setTimeout(() => {
            let table = document.querySelector(".js-water-payment-summary");

            // Scroll only if results are not in top 60% of the viewport
            if (table && table.getBoundingClientRect().top > window.innerHeight*0.6) {
                table.scrollIntoView({ behavior: 'smooth' });
            }
        }, 100) 
    }
  }
}